import * as React from "react"
import Svg, { Circle, Path } from "react-native-svg"

function AddressIcon(props) {
    return (
        <Svg
            xmlns="http://www.w3.org/2000/svg"
            width={40}
            height={40}
            viewBox="0 0 40 40"
            fill="none"
            {...props}
        >
            <Circle cx={20} cy={20} r={20} fill={props?.bg ?? "#EBF2FF"} />
            <Path
                d="M20 19.75c.483 0 .896-.17 1.238-.512.341-.342.512-.755.512-1.238s-.17-.896-.512-1.238A1.686 1.686 0 0020 16.25c-.483 0-.896.17-1.238.512A1.686 1.686 0 0018.25 18c0 .483.17.896.512 1.238.342.341.755.512 1.238.512zm0 8.275c2.217-2.017 3.854-3.846 4.913-5.487C25.97 20.896 26.5 19.45 26.5 18.2c0-1.967-.63-3.575-1.887-4.825C23.354 12.125 21.817 11.5 20 11.5c-1.817 0-3.354.625-4.613 1.875-1.258 1.25-1.887 2.858-1.887 4.825 0 1.25.542 2.696 1.625 4.338 1.083 1.641 2.708 3.47 4.875 5.487zm.025 1.675c-.117 0-.225-.017-.325-.05a.883.883 0 01-.275-.15c-2.483-2.183-4.342-4.208-5.575-6.075C12.617 21.558 12 19.817 12 18.2c0-2.5.804-4.492 2.412-5.975C16.021 10.742 17.883 10 20 10s3.98.742 5.587 2.225C27.197 13.708 28 15.7 28 18.2c0 1.617-.617 3.358-1.85 5.225-1.233 1.867-3.092 3.892-5.575 6.075a.924.924 0 01-.262.15.836.836 0 01-.288.05z"
                fill={props?.color ?? "#2D57D9"}
            />
        </Svg>
    )
}

export default AddressIcon
